export default __webpack_public_path__ + "static/media/sainapse_logo2.f4b961db.png";